
import Vue from 'vue'
import { mdiCheckCircle } from '@mdi/js'
import { Items } from '~/types'

export default Vue.extend({
  data() {
    return {
      mdiCheckCircle,
      img1: '/featureOverview/featureOverview.png',
      sectionItems: [
        {
          title: '紙いらず',
          icon: require('~/assets/icon/featurePage/touchIcon.svg'),
          subTitle: '予約表/問診票/カルテなどタブレットへ直接入力',
        },
        {
          title: '助かる',
          icon: require('~/assets/icon/featurePage/touchIcon.svg'),
          subTitle: 'タブレット1つで運営可能、新規オープンもカンタン',
        },
        {
          title: '活用できる',
          icon: require('~/assets/icon/featurePage/touchIcon.svg'),
          subTitle: '様々な入力したデータを蓄積自動的にCRM/POSへ反映・分析',
        },
      ],
      featureListTitle: '関連機能の紹介',
      featureListItems2: [
        {
          title: '予約',
          link: '/functions/reservations',
          icon: 'solid-calendar',
          chipItems: [
            {
              text: 'Web予約からの自動データ取得',
            },
          ],
        },
        {
          title: '電子カルテ',
          link: '/functions/karte',
          icon: 'person-comment',
          chipItems: [
            {
              text: 'カスタムカルテ情報管理',
            },

            {
              text: '経過記録電子化',
            },
          ],
        },
        {
          title: 'POS',
          link: '/functions/pos',
          icon: 'pos',
          chipItems: [
            {
              text: '自動集計',
            },
            {
              text: '午前/午後の売上集計',
            },
          ],
        },
      ],
      featureListItems1: [
        {
          title: '予約',
          link: '/functions/reservations',
          icon: 'solid-calendar',
          chipItems: [
            {
              text: 'スタッフ別・ベット別予約受付',
            },
            {
              text: 'ダブルブッキング防止',
            },
          ],
        },
        {
          title: '電子カルテ',
          link: '/functions/karte',
          icon: 'person-comment',
          chipItems: [
            {
              text: '画像カスタマイズ',
            },
            {
              text: 'カスタムカルテ',
            },
          ],
        },
        {
          title: 'POS',
          link: '/functions/pos',
          icon: 'pos',
          chipItems: [
            {
              text: 'レジ金の自動集計',
            },
          ],
        },
      ],
      paperlessFeatureList: [
        {
          img: require('~/assets/Benefits/feature1.png'),
          title: '予約受付を自動管理',
          desc: '来院確認と同時に予約表から施術メニューや金額計算など様々な書類を自動作成。ペーパーレス化により、業務の大幅な効率化を後押しします。',
        },
        {
          img: require('~/assets/Benefits/feature2.png'),
          title: '紙ではできないことが実現',
          desc: '問診票・施術録をデジタル化。姿勢やケガの度合いなど、言語よりも視覚の方が伝わり易い写真を画像データとして保存する事ができます。',
        },
        {
          img: require('~/assets/Benefits/feature3.png'),
          title: 'お会計もワンクリック！',
          desc: '会計、日次集計、午前午後での集計などを自動的に算出するため、面倒な日次締め処置からの解放。一目でリアルタイムな売上状況を把握することもできます。',
        },
      ] as Items[],
      helpingFeatureList: [
        {
          img: require('~/assets/featureOverview/feature04.png'),
          title: '院内業務と連動して更新される',
          desc: '常に最新の店舗データ 予約管理や問診・施術録、会計・レシート発行などの院内業務がWeb上で完結。業務の大幅な効率化を後押しします。',
        },
        {
          img: require('~/assets/featureOverview/feature05.png'),
          title: '営業後の締め作業とおさらば',
          desc: 'ひとり一人の患者の保険・自費・物販などの集計も自動作成。営業後の締め作業がなくなります。営業時間終了後と同時に帰宅することが実現。',
        },
        {
          img: require('~/assets/featureOverview/feature06.png'),
          title: '脱表計算ソフト、脱アナログ',
          desc: '「どれが最新のファイルかわからない」「誤って上書きしてしまった」「数式が壊れた」「データ入力が大変」もうこれらの問題に悩まされることはありません。',
        },
      ] as Items[],
      workingFeatureList: [
        {
          img: require('~/assets/featureOverview/feature07.png'),
          title: 'リアルタイムでいまがわかる',
          desc: '来院数・単価・頻度などの数字が自動集計。施術者は業務に集中できる環境が作られ、効果的・効率的な店舗運営が実現。売上向上につながります。',
        },
        {
          img: require('~/assets/featureOverview/feature08.png'),
          title: 'スタッフ評価に活用',
          desc: '個人売上・リピート率などの収集や分析が可能。業務効率だけでなくスタッフ評価の活用まで対応しています。',
        },
        {
          img: require('~/assets/featureOverview/feature09.png'),
          title: '早期常連化が実現',
          desc: '来院時の接客・会話の履歴が可視化されることで、それぞれの顧客とスタッフの情報共有が可能になり、早期常連化が実現。来店頻度・リピート率の向上につながります。',
        },
      ] as Items[],
      paperlessData: {
        img: require('~/assets/reservationCal.png'),
        sectionNumber: '紙いらず',
        title:
          'タブレット１つで、店舗運営が可能で、 店舗運営の中で、自然と必要情報が集まる',
        desc: '予約票も問診表・施術録もペーパーレスでカンタン。しかも、印刷不要なので手間もいらず、保管場所を確保する必要もなくなります。データはクラウド上で保管・管理されるので、紛失の恐れなく、安全に管理できます。',
      },
      helpData: {
        img: require('~/assets/featureCRM.png'),
        sectionNumber: '助かる',
        desc: '来院患者のカルテ探しから、回数券の管理、数週間後の予約確認など、あらゆるシーンで必要な院内業務がスマート治療院で完結。自動でデータベースが更新されます。患者・スタッフ情報が自然に集約されるので、常に最新で間違いのない店舗データをカンタンに一元管理できます。',
      },
      workData: {
        img: require('~/assets/crm.png'),
        sectionNumber: '活用できる',
        desc: '院内業務で入力された情報から会計まで集約されるのはもちろん、来院・購買履歴から電子カルテを使って撮影された画像まで自動的に更新されます。だから常に店舗の最新情報がCRMで確認できます。',
      },
    }
  },
})
